export default function OpeningSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="bg-white rounded-xl shadow-2xl p-8 md:p-12 border border-gray-200">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            あなたは今、こんな不安を<br className="md:hidden" />抱えていませんか？
          </h2>

          <div className="flex flex-col lg:flex-row gap-8 items-center">
            {/* Concerns list */}
            <div className="w-full lg:w-3/5 space-y-5">
              {[
                '念願のマイホームを買ったけれど、毎月のローン返済が家計を圧迫している…',
                '子供の成長は嬉しいが、これからかかる教育費を計算するとゾッとする…',
                '本業は忙しく、上司や取引先との付き合いで家族との時間が取れない…',
                '会社で出世しても、年収はそんなに上がらない。将来が見えてしまった気がする…',
                'ふるさと納税やNISAはやっているが、それだけで本当に足りるのか不安だ…'
              ].map((text, index) => (
                <div key={index} className="flex items-start gap-4 p-6 bg-gray-50 rounded-lg hover:bg-amber-50 hover:border-amber-200 transition-all border border-gray-100">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-gray-800 to-gray-900 text-white rounded-lg flex items-center justify-center font-bold text-lg shadow-md">
                    {index + 1}
                  </div>
                  <p className="text-gray-800 text-base md:text-lg leading-relaxed pt-1.5">
                    {text}
                  </p>
                </div>
              ))}
            </div>

            {/* Illustration */}
            <div className="w-full lg:w-2/5 flex justify-center">
              <div className="relative w-full max-w-md" style={{ paddingBottom: '100%' }}>
                <img
                  src="https://public.readdy.ai/ai/img_res/3a721f8a77012fd7c33254a385f0fd1e.jpg"
                  alt="悩むサラリーマン"
                  className="absolute inset-0 w-full h-full object-cover object-top rounded-xl shadow-lg"
                />
              </div>
            </div>
          </div>

          <div className="mt-12 p-8 bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl">
            <p className="text-base md:text-2xl font-bold text-white text-center leading-relaxed">
              もし、ひとつでも当てはまるなら──<br className="hidden md:block" />
              住宅費が&quot;ほぼ無料&quot;になれば、すべて解決しませんか？
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}